import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Input from "../../../components/forms-fields/Input";
import { updateArchiveStaffDate } from "../../../schemas";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UPDATE_STAFF_MEMBERS_URL } from "../../../env";
import {
    getRecords,
    postRecords,
    catchAsync,
    isSuccess,
    toastSuccessMessages,
    toastErrorMessages,
} from "../../../helper/helper";
import moment from "moment/moment";

function UpdateArchiveData({ staffMemberDetail, subModalArchiveStaff, futureArchive }) {
    // console.log("🚀 ~ UpdateArchiveData ~ staffMemberDetail:", staffMemberDetail)

    const handleShowHideModal = () => {
        subModalArchiveStaff((prevShow) => !prevShow);
    };
    const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
    const [isToastArchiveStaff, setIsToastArchiveStaff] = useState(false);

    const [selectedUserId, setSelectedUserId] = useState(staffMemberDetail?.staffMemberid);

    const [suFormData, setSuFormData] = useState({
        staffMemberid: selectedUserId,
        archiveDate: new Date(staffMemberDetail?.archiveDate)
    });

    const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        setValues,
    } = useFormik({
        initialValues: suFormData,
        validationSchema: updateArchiveStaffDate,
        onSubmit: async (values) => {
            try {
                setIsSubmitButtonClicked(true);
                await postArchiveStaffFormData(values);
            } catch (error) {

            }
        },
    });
    console.log("🚀 ~ UpdateArchiveData ~ values:", values)

    const processPostRecords = (method, data) => {
        if (data?.status !== isSuccess) {
            setIsToastArchiveStaff(true);
            toastErrorMessages(toast.error, data?.message, "", 500, 500);
            setIsSubmitButtonClicked(false);
            setTimeout(() => {
                handleShowHideModal();
                setIsToastArchiveStaff(false)
            }, 2000);
        } else if (
            method === "postArchiveStaffFormData" &&
            data?.status === isSuccess
        ) {
            setIsToastArchiveStaff(true);
            toastSuccessMessages(toast.success, data?.message, "", 500, 500);
            setIsSubmitButtonClicked(false);
            setTimeout(() => {
                handleShowHideModal();
                setIsToastArchiveStaff(false)
            }, 2000);
        }
    };

    const postArchiveStaffFormData = catchAsync(async (req, res) => {
        const updatedValues = {
            ...values,
            archiveDate: moment(values.archiveDate).valueOf(),

        };
        // console.log("🚀 ~ UpdateArchiveData ~ updatedValues:", updatedValues)
        const response = await postRecords(UPDATE_STAFF_MEMBERS_URL, updatedValues);
        console.log("🚀 ~ UpdateArchiveData ~ response:", response)
        processPostRecords("postArchiveStaffFormData", response);
        setIsSubmitButtonClicked(false);
    });



    const [apiQuery, setApiQuery] = useState({
        startDate: "",
        staffMemberid: ""
    });


    // Getting records from DB
    const processFetchRecords = (method, data) => {
        if (method === "get" && data?.status === isSuccess) {
            const holidayStock = data?.data;
            // setFilterSearch(holidayStock);
            setFieldValue("hldRqTotalHours", holidayStock?.totalHours);
        } else if (method === "delete" && data?.status === isSuccess) {

            setTimeout(() => {
                // setIsHolidaysGroup(false);
            }, 2000);
        }
    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const response = await getRecords(UPDATE_STAFF_MEMBERS_URL, apiQuery);

        processFetchRecords("get", response);
    });

    useEffect(() => {
        setApiQuery({
            startDate: moment(values?.archiveDate).valueOf(),
            staffMemberid: values?.staffMemberid
        })

    }, [values?.staffMemberid, values?.archiveDate]);

    useEffect(() => {
        fetchAllRecords();
    }, [apiQuery]);


    return (
        <>
            <div className="incidents consentCapacityAddNew">
                <form onSubmit={handleSubmit}>
                    <div className="formBlockContent">
                        <div className="row">
                            <div className="col-md-12  minHeight250">
                                <Input
                                    type="date"
                                    name="archiveDate"
                                    selected={values.archiveDate ? moment(values.archiveDate).valueOf() : null}
                                    dateFormat="dd/MM/yyyy"
                                    onChange={(date) => setFieldValue("archiveDate", moment(date).valueOf())}
                                    onBlur={handleBlur}
                                    labelText="Archive Date"
                                    customError={touched.archiveDate && errors.archiveDate}
                                    errorMessage={errors.archiveDate}
                                    datePicker={true} // ✅ This is the fix!
                                    placeholderText="Archive date"
                                // customError={touched.archiveDate && errors.archiveDate}
                                // errorMessage={errors.archiveDate}
                                />
                            </div>


                        </div>
                    </div>

                    <div className="formActionButtons">
                        <span
                            onClick={subModalArchiveStaff}
                            className={`btn btn-sm ${futureArchive ? "btn-outline-danger" : "btn-outline-primary"}`}
                        >
                            Close
                        </span>
                        {isSubmitButtonClicked ? (
                            <Button
                                onClick={subModalArchiveStaff}
                                className="btn-sm"
                                variant={futureArchive ? "danger" : "primary"}
                                disabled
                            >
                                Loading...
                            </Button>
                        ) : (
                            <Button className="btn-sm" variant={futureArchive ? "danger" : "primary"} type="submit">
                                Save
                            </Button>
                        )}
                    </div>
                </form>
            </div>
            {isToastArchiveStaff && <ToastContainer />}
        </>
    );
}

export default UpdateArchiveData;